import React from "react";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { WhyAIOU } from "../components/landing/WhyAIOU";
import { ProgramsSection } from "../components/landing/ProgramsSection";
import { FeeStructure } from "../components/landing/FeeStructure";
import { HowItWorks } from "../components/landing/HowItWorks";
import { GuidanceCTA } from "../components/landing/GuidanceCTA";
import { FAQSection } from "../components/landing/FAQSection";
import { Footer } from "../components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen w-full bg-aiou-paper">
      <Navbar />
      <main>
        <Hero />
        <WhyAIOU />
        <ProgramsSection />
        <FeeStructure />
        <HowItWorks />
        <GuidanceCTA />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
